import { render, staticRenderFns } from "./BeltsSelectStripes.vue?vue&type=template&id=40a6eb42&scoped=true"
import script from "./BeltsSelectStripes.vue?vue&type=script&lang=js"
export * from "./BeltsSelectStripes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6eb42",
  null
  
)

export default component.exports